import * as React from 'react';

interface IButtonProps extends React.HTMLProps<HTMLButtonElement> {
  bsClass?: string;
}

export default (props: IButtonProps) => {
  const {
    bsClass,
    ...ownProps
  } = props;
  return <button className={`btn ${bsClass ? bsClass : ''}`} {...ownProps} />;
};



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx